import React, {ComponentProps} from 'react'
import FieldWithLabel, {FieldType} from './FieldWithLabel'

const TextField = (props: Omit<ComponentProps<typeof FieldWithLabel>, 'type'>) => {
  return <FieldWithLabel {...props} type={FieldType.text}/>
}
TextField.displayName = 'TextField'
export default TextField
